import "./index.scss";
import { Button } from "components/UI/atoms";
import { Modal, PartnershipsForm } from "components/UI/molecules";
import { useState } from "react";

export const PartnershipsHeader = () => {
  const [isPopOverOpen, setPopOver] = useState(false);

  return (
    <div className="partnerships-header">
      <h1>Grow sales with the right customers.</h1>
      <h2>
        It's time to turn your branded currency into brand loyalty and
        incremental revenue.
      </h2>
      <Button onClick={() => setPopOver(true)} customClassName="modal-button">
        GET IN TOUCH
      </Button>
      <Modal
        customClassName="partnerships-modal"
        isOpen={isPopOverOpen}
        onBackdropClick={() => setPopOver(false)}
        header={
          <>
            <h3>Contact Our Merchant Partner Team</h3>
            <button onClick={() => setPopOver(false)}>&#x2716;</button>
          </>
        }
      >
        <PartnershipsForm />
      </Modal>
    </div>
  );
};
